import { render, staticRenderFns } from "./OurBusiness.vue?vue&type=template&id=15e45e8e&scoped=true"
import script from "./OurBusiness.vue?vue&type=script&lang=js"
export * from "./OurBusiness.vue?vue&type=script&lang=js"
import style0 from "./OurBusiness.vue?vue&type=style&index=0&id=15e45e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e45e8e",
  null
  
)

export default component.exports